import React from 'react';
import { Button, ButtonGroup } from "react-bootstrap";

const Row = ({ offer, onRemove, onUpdate}) => {
    return (<tr>
        <td>{offer.name}</td>
        <td>{offer.title}</td>
        <td>{offer.body}</td>
        <td>{offer.icon}</td>
        <td>{offer.image}</td>
        <td>{offer.url}</td>
        <td>
            <ButtonGroup>
                <Button bsStyle="info" onClick={() => onUpdate(offer)}>Update</Button>
                <Button bsStyle="danger" onClick={() => onRemove(offer.id)}>Remove</Button>
            </ButtonGroup>
        </td>
    </tr>);
};

export default Row;



// WEBPACK FOOTER //
// ./src/scenes/AdkBannerDefaultOffers/components/Table/components/Row/index.js